import React from "react";
import { Subscription } from "rxjs";
import NavigationTokens from "../constants/navigationTokens";
import { IDisplayState } from "../interfaces/IDisplayState";
import NavigationTokensService from "../utilities/navigationTokensService";
import UserService from "../utilities/userService";
import AccountInfo from "./accountInfo/accountInfo";
import LoginUrlService from "../utilities/loginUrlService";

const adobeMarketingId = "header-callout";

type HeaderTopProps = {
  marketingDivCallback: () => void;
  isLoggedIn: boolean;
  isCookied: boolean;
  accountNumber: string;
  displayState: IDisplayState;
  customerAccountName: string;
  userConfigurations: number;
  userConfigId?: string;
};

type HeaderTopState = {
  switchAccountHref: string;
  gsaHref: string;
  adobeMarketingDivHtml: string;
};

class HeaderTop extends React.Component<HeaderTopProps, HeaderTopState> {
  private observer: MutationObserver | null = null;
  private navTokenSub: Subscription | null = null;

  constructor(props: HeaderTopProps) {
    super(props);
    this.state = {
      switchAccountHref: "",
      gsaHref: "",
      adobeMarketingDivHtml: "",
    };

    this.getAdobeMarketingDivHtml = this.getAdobeMarketingDivHtml.bind(this);
  }

  componentDidMount() {
    const switchAccountUrl = LoginUrlService.getPreLoadedSwitchAccountUrl();
    this.navTokenSub = NavigationTokensService.get([
      NavigationTokens.wbGsa,
    ]).subscribe((navTokens) => {
      this.setState({
        switchAccountHref: switchAccountUrl,
        gsaHref: navTokens[NavigationTokens.wbGsa],
      });
    });

    if (typeof document !== "undefined") {
      this.getAdobeMarketingDivHtml();

      // Select the node that will be observed for mutations
      const targetNode = document.getElementById(adobeMarketingId);
      if (targetNode !== null) {
        // Options for the observer (which mutations to observe)
        const config = { childList: true };

        if (typeof MutationObserver !== "undefined") {
          // Create an observer instance linked to the callback function
          this.observer = new MutationObserver(() => {
            this.getAdobeMarketingDivHtml();
          });

          // Start observing the target node for configured mutations
          this.observer.observe(targetNode, config);
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }

    if (this.navTokenSub) {
      this.navTokenSub.unsubscribe();
    }
  }

  getAdobeMarketingDivHtml() {
    if (typeof document !== "undefined") {
      const element = document.getElementById(adobeMarketingId);

      if (element && element.innerHTML && UserService.displayUserInfo()) {
        this.setState({ adobeMarketingDivHtml: element.innerHTML });
        this.props.marketingDivCallback();
      }
    }
  }

  renderAdobeMarketing(isMobile: boolean) {
    return (
      <>
        {this.state.adobeMarketingDivHtml && (
          <span
            className={
              isMobile
                ? "header-top-mobile row d-lg-none"
                : "marketing-div-desktop"
            }
            dangerouslySetInnerHTML={{
              __html: this.state.adobeMarketingDivHtml,
            }}
          ></span>
        )}
      </>
    );
  }

  render() {
    return (
      <>
        {this.renderAdobeMarketing(true)}
        <div className="d-none d-lg-block header-top-desktop row">
          <div className="col-12 col-padding-modifier">
            {this.renderAdobeMarketing(false)}
            <span className="right-hand">
              <AccountInfo
                isLoggedInOrCookied={
                  this.props.isLoggedIn || this.props.isCookied
                }
                displayAccountName={
                  this.props.displayState.displayAccountNameOnMasterPage
                }
                customerAccountName={this.props.customerAccountName}
                hasMultipleAccounts={this.props.userConfigurations > 1}
                switchAccountHref={this.state.switchAccountHref}
                gsaLinkText={
                  this.props.displayState.displayGsaLink
                    ? this.props.displayState.gsaLinkText
                    : ""
                }
                gsaHref={this.state.gsaHref}
                accountNumber={this.props.accountNumber}
                displayState={this.props.displayState}
                userConfigId={this.props.userConfigId}
              />
            </span>
          </div>
        </div>
      </>
    );
  }
}

export default HeaderTop;
